module.exports = __webpack_public_path__ + "img/jamesway_logo.fdfc8a02.png";